import type { IStorageOptions } from './types';
import { ClientStorage } from './ClientStorage';

export class SessionStorage extends ClientStorage {
  public constructor(options?: IStorageOptions) {
    super(sessionStorage, options);
  }
}
